module.exports = __webpack_public_path__ + "img/automated-rail-transportation.e63b34f2.png";